import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from '@/common/utils/formatters'
import { ControlledByType } from '@/features/privateCompanies/types/companyGovernmentAllocation.type'
import { CompanyGovernmentAllocationEntryProductCategory } from '@/features/privateCompanies/types/companyGovernmentAllocationEntry.type'

export const updateGovernmentAllocationEntryProductCategoryDefaultValues = (
  entryProductCategory: CompanyGovernmentAllocationEntryProductCategory,
  controlledBy: ControlledByType = 'currency',
  governmentAllocationCurrencyRestricted: boolean | undefined,
) => {
  if (controlledBy === 'quantity') {
    return {
      id: entryProductCategory.id,
      product_category: entryProductCategory.product_category,
      total_quantity: formatDecimalWithGroupedUnit(
        Number(entryProductCategory.total_quantity),
        entryProductCategory.entry_products,
        (p) => p.product.unit_for_quantity,
      ),
      total_value: governmentAllocationCurrencyRestricted
        ? formatCurrency(Number(entryProductCategory.total_value) || 0)
        : undefined,
      entry_products: entryProductCategory.entry_products.map((productDistribution) => {
        return {
          id: productDistribution.id,
          product: productDistribution.product,
          total_quantity: formatDecimalUnit(Number(productDistribution.total_quantity), productDistribution.product.unit_for_quantity),
          total_value: governmentAllocationCurrencyRestricted
            ? formatCurrency(Number(productDistribution.total_value) || 0)
            : undefined,
        }
      }),
      governmentAllocationCurrencyRestricted,
    }
  }

  return {
    id: entryProductCategory.id,
    product_category: entryProductCategory.product_category,
    total_value: formatCurrency(Number(entryProductCategory.total_value) || 0),
    entry_products: entryProductCategory.entry_products.map((productDistribution) => {
      return {
        id: productDistribution.id,
        product: productDistribution.product,
        total_value: formatCurrency(Number(productDistribution.total_value) || 0),
      }
    }),
    governmentAllocationCurrencyRestricted,
  }
}
